import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type ToastType = 'success' | 'error' | 'info' | 'warning';
export type Toast = {
  id: number,
  title: string,
  msg: string,
  type: ToastType,
  duration: number;
}

@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  private toasts: Toast[] = [];
  private toastsSubject: BehaviorSubject<Toast[]> = new BehaviorSubject<Toast[]>([]);
  toasts$: Observable<Toast[]> = this.toastsSubject.asObservable()

  private show(title: string, msg: string, type: ToastType, duration: number = 3000): number {
    const id: number = Date.now();
    const toast: Toast = { id, title, msg, type, duration };
    this.toasts.push(toast);
    this.toastsSubject.next(this.toasts);
    setTimeout(() => this.remove(id), duration);
    return id
  }

  remove(id: number): void {
    this.toasts = this.toasts.filter((t: Toast) => t.id !== id);
    this.toastsSubject.next(this.toasts);
  }

  success(title: string, msg: string, duration: number = 3000): number {
    return this.show(title, msg, 'success', duration);
  }

  error(title: string, msg: string, duration: number = 3000): number {
    return this.show(title, msg, 'error', duration);
  }

  info(title: string, msg: string, duration: number = 3000): number {
    return this.show(title, msg, 'info', duration);
  }

  warning(title: string, msg: string, duration: number = 3000): number {
    return this.show(title, msg, 'warning', duration);
  }
}
